import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Logo } from "@/components/site/Navbar";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (er) {
      toast.error(errMsg(er));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="hidden flex-col justify-between bg-[#0B132B] p-12 text-white blueprint-grid-dark lg:flex">
        <Logo dark />
        <div>
          <p className="eyebrow mb-4">CMS · Knowledge Base · Lead Tracker</p>
          <h1 className="text-4xl font-extrabold leading-tight">Pusat kendali konten, prospek, dan otak AI perusahaan.</h1>
        </div>
        <p className="font-mono text-xs text-slate-500">Akses terbatas untuk administrator.</p>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="admin-login-form">
          <span className="grid h-12 w-12 place-items-center bg-[#0F2B48] text-white"><Lock size={20} /></span>
          <h2 className="text-2xl font-bold text-[#0F2B48]">Masuk Admin CMS</h2>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="login-email-input" className="w-full border border-slate-300 px-4 py-3 text-sm outline-none focus:border-[#D97706]" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="login-password-input" className="w-full border border-slate-300 px-4 py-3 text-sm outline-none focus:border-[#D97706]" />
          <button disabled={busy} data-testid="login-submit-button" className="w-full bg-[#0F2B48] py-3 text-sm font-bold text-white transition-colors hover:bg-[#D97706] disabled:opacity-60">{busy ? "Memproses..." : "Masuk"}</button>
        </form>
      </div>
    </div>
  );
}
